// IMPORTANT: After modifying this file, update CHANGELOG.md with a summary of your changes.
// Add clear comments for non-obvious changes, including what replaced prior behavior, to avoid repeating failed fixes.

// Typed client helper for the OpenAI Ads measurement pixel (`oaiq`).
// The global `window.oaiq` stub is defined ungated in <head> by
// OpenAiAdsPixel, so calls made here always queue safely; they only flush to
// the network once the SDK loads (which is consent-gated). See
// src/components/OpenAiAdsPixel.tsx.

declare global {
  interface Window {
    oaiq?: (...args: unknown[]) => void;
  }
}

export interface OaiqMeasureData {
  // OpenAI's documented fields (e.g. order_created). `type` is the event
  // sub-type ("contents"); amount is in minor units; currency is ISO-4217.
  type?: string;
  amount?: number;
  currency?: string;
  [key: string]: unknown;
}

export interface OaiqMeasureOptions {
  // Pass a stable id to dedupe against a matching server-side Conversions API
  // event (recommended for purchases/leads). Optional for page views.
  event_id?: string;
}

/**
 * Send a browser conversion event to the OpenAI Ads pixel. No-op on the
 * server, and a safe queue-push before the SDK has loaded.
 */
export function oaiqMeasure(
  event: string,
  data: OaiqMeasureData = {},
  options?: OaiqMeasureOptions
): void {
  if (typeof window === "undefined" || typeof window.oaiq !== "function") {
    return;
  }
  if (options) {
    window.oaiq("measure", event, data, options);
  } else {
    window.oaiq("measure", event, data);
  }
}
